import { render } from "./AddSection1.vue?vue&type=template&id=7160b78d&scoped=true"
import script from "./AddSection1.vue?vue&type=script&lang=js"
export * from "./AddSection1.vue?vue&type=script&lang=js"

import "./AddSection1.vue?vue&type=style&index=0&id=7160b78d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7160b78d"]])

export default __exports__